import type { ErrorResponse } from '@/shared/api/types';

/**
 * Extracts the backend error message from a thrown RTK Query error, if present.
 *
 * Backend HTTP errors carry an `ErrorResponse` body (`{ message }`) under
 * `error.data`; network / timeout / parse errors have no `data`, so `fallback`
 * is returned. Pair it with a mutation helper's `onError` callback.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as { data?: Partial<ErrorResponse> } | undefined)?.data;
  return data?.message ?? fallback;
};
